module.exports = __webpack_public_path__ + "media/images/team/marlito-odosis-4cd22de178f578ec8c2b5dcb2f24bf5a.png";